import IvicosStrings from 'kits/language/stringKit';

export function formatDateToLocale(d: Date): string {
    const lang = localStorage.getItem('chosenLanguage') || 'de';
    return d.toLocaleDateString(lang === 'de' ? 'de-DE' : 'en-GB', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
    });
}

function parseTimeToMinutes(time: string): number {
    const [h, m] = time.split(':').map(Number);
    return h * 60 + m;
}

function isOooReturnInPast(returnDate: Date, returnTime?: string | null): boolean {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const rd = new Date(returnDate);
    rd.setHours(0, 0, 0, 0);

    if (rd < today) return true;

    const isToday = rd.getTime() === today.getTime();
    if (isToday && returnTime) {
        const now = new Date();
        const nowMinutes = now.getHours() * 60 + now.getMinutes();
        return parseTimeToMinutes(returnTime) < nowMinutes;
    }
    return false;
}

export function getOutOfOfficePhrase(absenceComment: string, returnDate: Date | undefined, returnTime?: string | null): string | undefined {
    if (!absenceComment.trim()) return undefined;
    if (!returnDate) return absenceComment.trim();

    const comment = absenceComment.trim();
    const preposition = isOooReturnInPast(returnDate, returnTime) ? IvicosStrings.since : IvicosStrings.until;

    const today = new Date();
    const isToday = returnDate.getDate() === today.getDate() && returnDate.getMonth() === today.getMonth() && returnDate.getFullYear() === today.getFullYear();

    if (isToday && returnTime) {
        return `${comment} ${preposition} ${returnTime.trim()}`;
    }
    if (isToday) {
        return comment;
    }

    return `${comment} ${preposition} ${formatDateToLocale(returnDate)}`;
}
